import { apiDirectCall } from "customHooks/useApi/api";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import useShowMessage from "customHooks/useShowMessage/useShowMessage";

export const useListPageFunctionsDeleteBranch = (t: any) => {
    const { readyForm, callDialog, agree } = useGlobalDialog();
    const showMessage = useShowMessage();

    const callDeleteDialog = async (rowData: any) => {
        return new Promise((resolve, reject) => {
            const uuid = rowData.skGS1pk.split(":")[1];
            const postAddress = `/branch/delete/${uuid}`;
            //const [deleteBranchReturn, deleteBranch] = useApi(postAddress, "post");

            callDialog({
                title: t("branchDelete_ModalTitle"),
                bodyText: t("branchDelete_Message"),
                agreeButtonText: t("branchDelete_Yes"),
                disagreeButtonText: t("branchDelete_No"),
                agreeFunction: async () => {
                    //const uuid = rowData.skGS1pk.split(":")[1];
                    //console.log("concordou", rowData, uuid);
                    const result = await apiDirectCall(
                        postAddress,
                        "post",
                        rowData
                    );
                    //console.log("retorno apiDirectCall", result);
                    if (result.status === 200) {
                        showMessage(t("successMessage"), "success");
                        //return true;
                        resolve(true);
                    }
                    resolve(false);
                },
                disagreeFunction: () => {
                    //console.log("discordou", rowData);
                    resolve(false);
                }
            });
        });
    };

    const listPageFunctions = [{ action: "delete", fn: callDeleteDialog }];

    return listPageFunctions;
};
